export default __webpack_public_path__ + "static/media/Print_Stripes.f2ae48db.svg";